import {
  createFileRoute,
  Outlet,
  redirect,
  useLocation,
} from '@tanstack/react-router';

import loginAnimation from '@assets/animations/login.json';
import loginBackground from '@assets/login-background.svg';
import logoHorizontal from '@assets/logo-horizontal.svg';
import logoJaimy from '@assets/logo-jaimy.png';
import { Lottie } from '@components/ui/lottie';
import { ScrollArea } from '@components/ui/scroll-area';
import { Separator } from '@components/ui/separator';

export const Route = createFileRoute('/_auth-layout')({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({
        to: '/tasks',
      });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  const { pathname } = useLocation();
  const { description, title } =
    titleAndDescriptionByPathname[pathname] ??
    titleAndDescriptionByPathname['/'];

  return (
    <div className="relative bg-white dark:bg-neutral-900">
      <ScrollArea className="h-dvh bg-transparent">
        <main className="flex min-h-dvh w-full flex-col">
          <div className="grid gap-x-4 lg:grid-cols-2 lg:gap-x-12">
            <div className="mx-auto mb-8 grid w-full p-4 md:mb-0 md:p-10 lg:my-10 lg:max-w-lg lg:p-12 xl:max-w-xl">
              {/* <Anchor className="text-primary-dark-one ml-auto flex w-fit">
                Request support
              </Anchor> */}

              <div className="my-auto">
                <div className="mb-14 grid">
                  <img
                    alt="Logo Fixxer Connect"
                    className="relative mb-4 w-auto md:h-5"
                    src={logoHorizontal}
                  />

                  <h1 className="text-primary-dark-one dark:text-primary text-3xl font-semibold">
                    {title}
                  </h1>
                  <p className="text-primary-dark-one dark:text-primary mt-1 font-light">
                    {description}
                  </p>

                  <div className="mt-2 flex items-center gap-x-6">
                    <span className="text-input flex whitespace-nowrap">
                      Your company
                    </span>
                    <Separator variant="auth" />
                    <img
                      alt="Jaimy logo"
                      className="max-w-32"
                      src={logoJaimy}
                    />
                  </div>
                </div>

                <Outlet />
              </div>
            </div>

            <div className="relative flex h-full items-center lg:min-h-screen">
              <img
                alt="Login background"
                className="absolute h-full w-full object-cover"
                src={loginBackground}
              />

              <Lottie
                className="relative mx-auto w-2/4 object-contain"
                src={loginAnimation}
              />
            </div>
          </div>
        </main>
      </ScrollArea>
    </div>
  );
}

const titleAndDescriptionByPathname: Record<
  string,
  { description: string; title: string }
> = {
  '/': {
    title: 'Log in to your account',
    description: 'Welcome back!',
  },
  '/forgot-password': {
    title: 'Reset my password',
    description:
      'Enter your email address and we will send you an email to reseet your password.',
  },
  '/reset-password': {
    title: 'Set a new password',
    description: 'Please enter your new password',
  },
};
